import React from 'react'

const ButtonLoad = (props) => {
  return (
    <div><button disabled className='btn btn-primary w3-margin w3-centered'>{props.value}</button></div>
  )
}

export default ButtonLoad